<template>
  <div class="goods-data-tab">
    <div class="filter">
      <div class="flex flex-align-center">
        <div class="label">直播场次</div>
        <el-select size="mini" v-model="live_id" placeholder="请选择" @change="getLiveProductList(true)">
          <el-option :label="item.live_time" :value="item.live_id" v-for="(item, index) in liveList" :key="index" />
        </el-select>
      </div>
      <div class="flex flex-align-center">
        <div class="label nowrap ml-30">商品名称</div>
        <el-input v-model="product_name" clearable placeholder="请输入商品名称" @input="getLiveProductList(true)"></el-input>
      </div>
    </div>
    <div class="total">共 {{ total }} 个带货商品</div>
    <el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
      <el-table-column label="商品信息" min-width="250">
        <template v-slot="{ row }">
          <div class="goods-info">
            <el-image :src="row.product_pic" />
            <div class="right">{{ row.product_name }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="live_price" min-width="100">
        <template v-slot:header>
          <tooltip label="售价" content="该商品在售价格" />
        </template>
      </el-table-column>
      <el-table-column prop="product_sale" label="销售额区间" min-width="150"></el-table-column>
      <!-- <el-table-column prop="convert_rate" min-width="100">
        <template v-slot:header>
          <tooltip label="转化指数" content="根据达人直播间中商品点击到订单的转化率，以及销售额综合计算得出" />
        </template>
      </el-table-column> -->
    </el-table>
    <yx-pagination
      :total="total"
      :current-page="pageInfo.page_index"
      :page-size="pageInfo.page_size"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </yx-pagination>
  </div>
</template>

<script>
import { getLiveProductList, getLiveBroadcast } from '@/api/talentCRM'
import tooltip from '../../../tooltip'

export default {
  name: 'goodsDataTab',
  props: {
    anchorUid: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    tooltip
  },
  data () {
    return {
      live_id: 0,
      liveList: [{ live_id: 0, live_time: '不限' }],
      product_name: '',
      list: [],
      total: 0,
      pageInfo: {
        page_index: 1,
        page_size: 20
      }
    }
  },
  methods: {
    getInfo() {
      if(!this.anchorUid) return
      this.getLiveBroadcast()
      this.getLiveProductList()
    },
    async getLiveBroadcast() {
      const { anchorUid: anchor_uid } = this
      const { code, data: { list = [] } = {} } = await getLiveBroadcast({ anchor_uid })
      if(code !== 0) return
      this.liveList.push(...list)
    },
    async getLiveProductList(isInit) {
      isInit && (this.pageInfo.page_index = 1)
      const { anchorUid: anchor_uid, live_id, pageInfo, product_name } = this
      if(!anchor_uid) return
      const { code, data: { list = [], page: { item_total = 0 } = {} } = {} } = await getLiveProductList({ anchor_uid, live_id, ...pageInfo, product_name })
      if(code !== 0) return
      this.list = list
      this.total = item_total
    },
    reset() {
      this.live_id = 0
      this.product_name = ''
      this.liveList = [{ live_id: 0, live_time: '不限' }]
      this.list = []
      this.total = 0
      this.pageInfo = {
        page_index: 1,
        page_size: 20
      }
    },
    sizeChange(size) {
      this.pageInfo.page_size = size
      this.getLiveProductList()
    },
    currentChange(index) {
      this.pageInfo.page_index = index
      this.getLiveProductList()
    }
  }
}
</script>

<style lang="less" scoped>
.goods-data-tab {
  padding: 0 12px 16px;
  .total {
    margin-top: 30px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
  .goods-info {
    display: flex;
    .el-image {
      width: 44px;
      height: 44px;
    }
    .right {
      font-size: 14px;
      margin-left: 12px;
      flex: 1;
    }
  }
  .filter {
    display: flex;
    align-items: center;
    border-bottom: 1px #eee dashed;
    padding-bottom: 8px;
    .label {
      font-size: 14px;
      color: #666;
      font-weight: bold;
      margin-right: 38px;
    }
  }
}
</style>
